import { useState } from 'react';

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setIsMenuOpen(false);
  };

  const sections = [
    { name: "About", id: "about" },
    { name: "Tech Stack", id: "techstack" },
    { name: "Projects", id: "projects" },
    { name: "Education", id: "education" },
    { name: "Contact", id: "contact" },
  ];

  return (
    <div className="fixed top-0 left-0 w-full z-50 backdrop-blur-md">
      <nav className="relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 relative z-10">
          {/* Main Navbar */}
          <div className="flex justify-between items-center">
            {/* Logo/Title */}
            <div className="text-3xl sm:text-4xl font-bold">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-neon-cyan to-neon-purple">
                PortFolio
              </span>
            </div>
            
            {/* Desktop Menu */}
            <ul className="hidden sm:flex space-x-6 text-lg text-white font-medium tracking-wide">
              {sections.map((item) => (
                <li
                  key={item.id}
                  className="hover:text-neon-cyan hover:drop-shadow-[0_0_8px_#00ffff] transition duration-300 cursor-pointer"
                  onClick={() => scrollToSection(item.id)}
                >
                  {item.name}
                </li>
              ))}
            </ul>
            
            {/* Mobile Menu Button */}
            <button 
              className="sm:hidden text-white p-2"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <div className="w-6 h-6 flex flex-col justify-center">
                <span className={`block h-0.5 w-full bg-white transition-all duration-300 ${isMenuOpen ? 'rotate-45 translate-y-1.5' : ''}`}></span>
                <span className={`block h-0.5 w-full bg-white my-1 transition-all duration-300 ${isMenuOpen ? 'opacity-0' : 'opacity-100'}`}></span>
                <span className={`block h-0.5 w-full bg-white transition-all duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-1.5' : ''}`}></span>
              </div>
            </button>
          </div>
          
          {/* Mobile Dropdown Menu */}
          <div className={`sm:hidden transition-all duration-300 overflow-hidden ${isMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}>
            <ul className="py-4 space-y-3">
              {sections.map((item) => (
                <li
                  key={item.id}
                  className="text-white hover:text-neon-cyan hover:drop-shadow-[0_0_8px_#00ffff] transition duration-300 cursor-pointer py-2 px-4 rounded-lg hover:bg-white/10 text-center"
                  onClick={() => scrollToSection(item.id)}
                >
                  {item.name}
                </li>
              ))}
            </ul>
          </div>
        </div>
        
        {/* Animated Wave Border */}
        <div className="absolute bottom-0 left-0 w-full h-[4px] overflow-hidden">
          <div 
             className="absolute top-0 left-0 h-full w-[200%]"
             style={{
               background: 'linear-gradient(90deg, rgba(0,247,255,0.2) 0%, rgba(0,247,255,1) 25%, rgba(0,247,255,0.2) 50%, rgba(0,247,255,1) 75%, rgba(0,247,255,0.2) 100%)',
               boxShadow: '0 0 10px 2px rgba(0,247,255,0.6)',
               animation: 'wave-border 4s linear infinite',
             }}
          />
        </div>
        <div className="absolute -bottom-[20px] left-0 w-full h-[20px] bg-gradient-to-b from-neon-cyan/20 to-transparent pointer-events-none" />
      </nav>
      {/* Wave keyframes */}
      <style>{`
        @keyframes wave-border {
          0% { transform: translateX(0%); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
}